<template>
  <div class="dizme_tm_section" id="process">
    <div class="dizme_tm_process">
      <div class="container">
        <div class="list">
          <ul>
            <li
              class="wow fadeInUp"
              data-wow-duration="1s"
              data-wow-delay="0.2s"
            >
              <div class="list_inner">
                <div class="icon">
                  <img style="max-width:100px;" src="/img/intro/puzzle_piece.png" alt="" />
                </div>
                <div class="title">
                  <h3>Interactive Learning</h3>
                </div>
                <div class="text">
                  <p>
                    Engage in fun and challenging activities uniquely designed to support your journey to PBE Mastery.
                  </p>
                </div>
              </div>
            </li>
            <li class="wow fadeInUp" data-wow-duration="1s">
              <div class="list_inner">
                <div class="icon">
                  <img style="max-width:100px;" src="/img/intro/line_graph.png" alt="" />
                </div>
                <div class="title">
                  <h3>Track Your Progress</h3>
                </div>
                <div class="text">
                  <p>
                    Monitor your readiness with detailed Readiness Scores and climb the ranks as you improve.
                  </p>
                </div>
              </div>
            </li>
            <li
              class="wow fadeInUp"
              data-wow-duration="1s"
              data-wow-delay="0.4s"
            >
              <div class="list_inner">
                <div class="icon">
                  <img style="max-width:100px;" src="/img/intro/trophy.png" alt="" />
                </div>
                <div class="title">
                  <h3>Earn and Compete</h3>
                </div>
                <div class="text">
                  <p>
                    Accumulate Activity Points and see how you stack up against others on our Leaderboards.                    
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  awesomeIdeaDark,
  awesomeIdeaLight,
  highQualityDark,
  highQualityLight,
  pixelPerfectDark,
  pixelPerfectLight,
  barChart
} from "@/svg";
export default {
  name: "ProcessComponent",
  data() {
    return {
      pixelPerfectLight,
      highQualityDark,
      awesomeIdeaDark,
      pixelPerfectDark,
      awesomeIdeaLight,
      highQualityLight,
      barChart
    };
  },
  components: {},
  props: {
    dark: { type: Boolean },
  },
};
</script>
